import { Box, Slider, Typography, Stack } from "@mui/material"
import { Dispatch } from "react";

interface IProps {
  label?: string
  min: number
  max: number
  step: number
  setValue: Dispatch<React.SetStateAction<number>>
  value: number
}

const DashboardSlider = ({label, min, max, step, setValue, value}: IProps) => {

  const handleChange = (event: Event, value: any) => {
    setValue(value)
  }

  return (
    <Box width={200} px={2} py={1} position={"absolute"} top={0} right={0} zIndex={999} sx={{backgroundColor: "white", opacity: 0.8}} >
      <Stack spacing={2} direction="row" sx={{ alignItems: 'center' }}>
        <Typography color={"primary"} variant="body2">{label}</Typography>
        <Slider
          onChange={handleChange}
          size="small"
          value={value}
          step={step}
          marks
          color="primary"
          min={min}
          max={max}
        />
      </Stack>
    </Box>
  )
}

export default DashboardSlider